export class CompanyDetails {
    logo_url: String;
    primary_domain: String;
    responseData: any;
    companyId: string;
    companyName: string;
    googleUrl: String;
    phoneNo: String;
    street: String;
    subAddress: String;
    linkedin_url: String;
    totalContact: number = 0;
    buyingIntelHasContent = false;
    isInternational: number;

}
export class ExecutiveIntel {
    executiveCount: Number = 0;
    executivesLoaded = false;
    executives = [];
}
export class FirmoGraphics {
    sector: String;
    compIndustry: String;
    size_range: String;
    revenue_range: String;
    revenue: String;
    employee_count: string;
    naics_codes: string;
    sic_codes: string;
}
export class BuyingIntel {
    domainName: String;
    NewsTotal = 0;
    PressTotal = 0;
    FundingTotal = 0;
    AcquisitionTotal = 0;
    owlerActiveTab = 'News';
}
export class Technographics {
    technographics = [];
    technographicCount = 0;
    primaryTechnographics: any;
}

export class TechnographicDetail {
    technology: { name: string, isKeyTech: boolean };
    techIntelCollapsed: boolean;
    productCount: number;
    providerCount: number;
    subCategory: Array<{
        subCategoryName: any,
        providers: Array<{
            name: any,
            products: Array<any>
        }>;
    }>;

}

export const ExecutiveIntelValue = {
    abbreviationValue: [{
        'key': 'Board',
        'value': 0
    },
    {
        'key': 'CEO',
        'value': 10
    },
    {
        'key': 'COO',
        'value': 20
    },
    {
        'key': 'CFO',
        'value': 30
    },
    {
        'key': 'CMO',
        'value': 40
    },
    {
        'key': 'CIO',
        'value': 50
    },
    {
        'key': 'CHRO',
        'value': 60
    },
    {
        'key': 'CCO',
        'value': 70
    },
    {
        'key': 'CSO',
        'value': 80
    },
    {
        'key': 'CDO',
        'value': 90
    },
    {
        'key': '',
        'value': 100
    }]
};
